// Copyright (c) Move Closer 2022.

import { IVersionResolver, Patch, PossibleVersion, VersionComparisonResult } from '@/bootstrap/updater'

/**
 * Remove stored category trees when no app version is present
 */
export class ClearCachesPatch extends Patch {
  public cleanup () {
    location.reload()
  }

  public apply (): void {
    window.caches.keys().then(function (names) {
      for (const name of names) {
        caches.delete(name)
      }
    })

    localStorage.clear()
  }

  public shouldApply (appVersion: IVersionResolver, storedVersion: PossibleVersion): boolean {
    return appVersion.compare(storedVersion, 2) !== VersionComparisonResult.Same
  }
}
